/** Weights are stored in lbs across Production; screens showing kg convert on the fly. */
export const LBS_PER_KG = 2.20462;

export function lbsToKg(weightInLbs: number): number {
  return weightInLbs / LBS_PER_KG;
}

export function kgToLbs(weightInKg: number): number {
  return weightInKg * LBS_PER_KG;
}
